import { makeStyles } from "@material-ui/core";
import { blue, grey } from "@material-ui/core/colors";
import { fade } from "@material-ui/core/styles/colorManipulator";

export default makeStyles((theme) => ({
  link: {
    color: "inherit",
    textDecoration: "none",
  },
  fileInput: {
    display: "none",
  },
  // Matches the open-in-new-tab button next to it, so the pair of icons fits
  // the attachment chip.
  copyLinkButton: {
    padding: theme.spacing(1),
  },

  separatorContainer: {
    width: "100%",
  },

  expandAllButton: {
    marginRight: "24px",
  },
  subTaskAccordion: {
    background: "transparent",
    padding: 0,
    "&:hover": {
      backgroundColor: "none",
    },
    "&$expanded": {
      height: "48px !important",
    },
  },
  disabled: {
    cursor: "pointer",
    color: grey[900],
    backgroundColor: "transparent !important",
    "&:hover": {
      backgroundColor: "none",
    },
  },
  disabledSummary: {
    opacity: "1 !important",
  },
  disableExpandIcon: {
    color: grey[300],
  },
  cursorDefaultValue: {
    cursor: "default",
  },
  subTask: {
    padding: "13.5px 8px",
  },
  subTaskText: {
    fontSize: 14,
    fontWeight: 400,
  },
  draftTitle: {
    fontSize: "16px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: 1.1,
    color: `${grey[500]} !important`,
  },
  // "Updated" marker on a sub-task whose answer moved on after the parent
  // submit. Sits inline after the title, so it takes the title's own size
  // rather than MUI's default 24px icon.
  //
  // Size only — the colour is applied INLINE at the call site, the same way
  // our `Alert` does it. A class loses here: the surrounding DONE/struck-through
  // row forces its grey with higher specificity (see `draftTitle`'s
  // `!important` right above), so the icon would come out grey.
  updatedIcon: {
    fontSize: 16,
  },
  optionTaskText: {
    textAlign: "right",
    fontSize: 12,
    color: grey[600],
    lineHeight: 1.5,
    fontWeight: 400,
  },
  accordionOptionTasksText: {
    textTransform: "uppercase",
    textAlign: "right",
    fontSize: 12,
    color: grey[600],
    lineHeight: 1.5,
    fontWeight: 400,
  },
  paper: {
    boxShadow: "none",
    border: `1px solid ${theme.palette.separator.main}`,
    background: theme.palette.otherElementsBackground.main,
    color: theme.palette.contrastText.main,
    borderRadius: theme.spacing(1),
    overflow: "hidden",
    "& div,p": {
      color: theme.palette.contrastText.main,
    },
    "& svg": {
      fill: theme.palette.contrastIcon.main,
    },
  },
  details: {
    display: "flex",
    paddingTop: 0,
    alignContent: "flex-end",
    flexDirection: "column",
  },
  accordionDetails: {
    margin: 0,
  },
  description: {
    marginBottom: theme.spacing(2),
  },
  descriptionDark: {
    "& a": {
      color: theme.palette.contrastText.main,
    },
  },
  paperDetails: {
    width: 480,
    padding: theme.spacing(2, 2, 3),
    marginBottom: theme.spacing(1),
    borderColor: theme.palette.separator.main,
    backgroundColor: fade(theme.palette.otherElementsBackground.main, 0.3),
    boxShadow: "none",
  },
  notBorder: {
    borderBottom: "none",
  },
  checkCompleted: {
    fill: "#4CAF50",
    width: 20,
    height: 20,
  },
  row: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  checkUncompleted: {
    fill: grey[500],
    width: 20,
    height: 20,
  },
  lineThrough: {
    textDecoration: "line-through",
  },
  listItemBox: {
    margin: 0,
  },
  listItemDivider: {
    marginLeft: 56,
    "&:last-child": {
      display: "none",
    },
  },
  subtaskIconBox: {
    margin: theme.spacing(1.75, 1, 1, 2),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  expandedSummaryIcon: {
    margin: "0 !important",
  },
  expandedAccordion: {
    margin: "0 !important",
  },
  expandedAccordionBorder: {
    borderTop: `1px solid ${theme.palette.separator.main}`,
  },
  expandedSummary: {
    margin: "0 !important",
  },
  rootAccordion: {
    flex: "1 1 auto",
    background: "transparent",
  },
  accordionNoBorder: {
    borderTop: 0,
    "&:before": {
      height: 0,
    },
  },
  ".MuiAccordion-root:before": {
    background: theme.palette.error.main,
  },

  separator: {
    display: "flex",
    height: 40,
    width: "100%",
    position: "relative",
    padding: theme.spacing(0, 2),
    alignItems: "center",
    "&::after": {
      content: "''",
      position: "absolute",
      display: "block",
      top: "50%",
      left: "50%",
      transform: "translate(-50%)",
      width: "calc(100% - 40px)",
      height: 1,
      background: blue.A100,
    },
  },
  separatorTitle: {
    background: fade(theme.palette.otherElementsBackground.main, 1),
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 500,
    color: `${blue.A100} !important`,
    paddingRight: theme.spacing(1),
    zIndex: 1,
    maxWidth: "75%",
  },
}));
